import AnikaRaisaChowdhury from '@/assets/images/facilitators/Anika_Raisa_Chowdhury.webp'
import AnikaTabassum from '@/assets/images/facilitators/Anika_Tabassum.webp'
import DaveKoziel from '@/assets/images/organizers/Dave_Koziol.png'
import DonWard from '@/assets/images/organizers/Don_Ward.png'
import HishamOdeh from '@/data/2024/assets/images/dev/Hisham_Odeh.jpg'
import HudaHussaini from '@/assets/images/facilitators/Huda_Hussaini_23.webp'
import KanikaMohan from '@/assets/images/facilitators/Kanika_Mohan.webp'
import KieranLlarena from '@/data/2023/dev/Kieran_Llarena.jpeg'
import MohamadAlabudi from '@/data/2023/dev/Mohamad_Alabudi.jpg'
import RosyShrestha from '@/assets/images/facilitators/Rosy_Shrestha.webp'
import ShahdMustafa from '@/data/2023/dev/Shahd_Mustafa.jpg'
import ShamsAhson from '@/assets/images/facilitators/Shams_Ahson.webp'
import ShashankaPrajapati from '@/assets/images/facilitators/Shashanka_Prajapati.jpeg'
import ZahraaAlhmood from '@/data/2023/dev/Zahraa_Alhmood.jpg'
import ZavaarShah from '@/assets/images/facilitators/Zavaar_Shah.webp'

export const teamData = [
  {
    id: 1,
    name: 'Don Ward',
    twitter: 'donwardpeng',
    avatar: DonWard,
    organization: 'Google',
    position: 'GDG Organizer',
    url: 'https://gdg.community.dev/u/m8t3sr/',
    devfest: 'organizer',
  },
  {
    id: 2,
    name: 'Dave Koziol',
    twitter: 'davekoziol',
    avatar: DaveKoziel,
    organization: 'Little Caesars',
    position: 'GDG Organizer',
    url: 'https://gdg.community.dev/u/mrejqp/',
    devfest: 'organizer',
  },
  {
    id: 3,
    name: 'Huda Hussaini',
    avatar: HudaHussaini,
    bio: `Huda is a computer science senior at UofM - Dearborn and Software Engineer Intern for Bosch USA. Huda is also heavily involved in the tech community as she serves as the vice president of the Google Developers Student Club at her university and is a Women Techmaker ambassador.`,
    organization: 'Bosch USA',
    position: 'Software Engineer Intern',
    devfest: 'facilitator',
  },
  {
    id: 4,
    name: 'Anika Raisa Chowdhury',
    avatar: AnikaRaisaChowdhury,
    bio: `Anika is a final year graduate student pursuing Masters of Science in Data Science and currently interning with the University of Michigan Information and Technology Services. She is a computer Engineer and is enthusiastic to learn and adapt to new advances in technology.Her passion extends beyong data and code, as she believes in the power of networking to connect people and ideas. She can be found on linkedin at: https://www.linkedin.com/in/anikaraisa/`,
    organization: 'University Of Michigan Information And Technology Services',
    position: 'Data Analyst Intern',
    devfest: 'facilitator',
  },
  {
    id: 5,
    name: 'Kanika Mohan',
    avatar: KanikaMohan,
    bio: `Kanika is a 3rd-year Computer Science student at UMichigan-Dearborn and an immigrant who moved to the United States in 2017 at the age of 13. With industry experience in both the automotive and aerospace sectors, Kanika is also an EV Scholar and the proud recipient of the 2023 $25,000 Altair Engineering scholarship. Her aspiration is to contribute to and help foster the growth of the tech community in Detroit, Michigan, upon graduation.`,
    organization: 'GE Aerospace',
    position: 'Digital Technology Intern',
    devfest: 'facilitator',
  },
  {
    id: 6,
    name: 'Shams Ahson',
    avatar: ShamsAhson,
    bio: `Shams is a 3rd-year Cybersecurity and Information Assurance student at the University of Michigan Dearborn and the president and lead for the GDSC chapter. She is also a cybersecurity testing intern at ETAS, a subsidiary of Bosch. She is very involved in the tech community through organization of various events including UM Dearborn's first ever hackathon, Hack Dearborn and through Google Developer Groups.`,
    organization: 'UM Dearborn',
    position: 'GDSC Lead',
    devfest: 'facilitator',
  },
  {
    id: 7,
    name: 'Anika Tabassum',
    avatar: AnikaTabassum,
    bio: `Anika is a Computer Engineering senior at Western Michigan University (WMU) and a Research Assistant at the Energy Efficiency and Autonomous Vehicles Lab at WMU. She is also a returning Embedded Software Test Engineer Intern for Gentex. Anika also serves as the president of the Google Developers Student Club at her university. Her LinkedIn: http://linkedin.com/in/anikatabassum19`,
    organization: 'Western Michigan University',
    position: '',
    devfest: 'facilitator',
  },
  {
    id: 8,
    name: 'Rosy Shrestha',
    avatar: RosyShrestha,
    bio: `She works as a software engineer at Epitec. She is also pursuing her second-year graduate studies in software engineering at the University of Michigan-Dearborn. Her passion revolves around utilizing technology to ensure accessibility to information for everyone. Actively engaged in fostering inclusivity, she is on the board in the Society of Women Engineers@UM Dearborn and contributes her technical skills to the Google Developer Student Club. Beyond her professional pursuits, she volunteers as a tech mentor for the non-profit organization Bobatalk, exemplifying a commitment to giving back to the community through her expertise.`,
    organization: 'Epitec',
    position: 'Software Engineer',
    devfest: 'facilitator',
  },
  {
    id: 9,
    name: 'Shashanka Prajapati',
    avatar: ShashankaPrajapati,
    bio: ``,
    organization: 'University of Michigan - Dearborn',
    position: 'Graduate Student',
    devfest: 'facilitator',
  },
  {
    id: 10,
    name: 'Rosy Shrestha',
    linkedin: 'https://www.linkedin.com/in/rosyshrestha',
    github: 'https://github.com/shrestharosy',
    avatar: RosyShrestha,
    bio: `She works as a software engineer at Epitec. She is also pursuing her second-year graduate studies in software engineering at the University of Michigan-Dearborn. Her passion revolves around utilizing technology to ensure accessibility to information for everyone. Actively engaged in fostering inclusivity, she is on the board in the Society of Women Engineers@UM Dearborn and contributes her technical skills to the Google Developer Student Club. Beyond her professional pursuits, she volunteers as a tech mentor for the non-profit organization Bobatalk, exemplifying a commitment to giving back to the community through her expertise.`,
    university: 'University of Michigan - Dearborn',
    organization: 'Epitec',
    position: 'Software Engineer',
    devfest: 'devteam',
  },
  {
    id: 11,
    name: 'Shashanka Prajapati',
    linkedin: 'https://www.linkedin.com/in/shashanka-prajapati',
    github: 'https://github.com/sp-95',
    avatar: ShashankaPrajapati,
    bio: ``,
    university: 'University of Michigan - Dearborn',
    organization: '',
    position: 'Graduate Student',
    devfest: 'devteam',
  },
  {
    id: 12,
    name: 'Kieran Llarena',
    linkedin: 'https://www.linkedin.com/in/kllarena07',
    github: 'https://github.com/kllarena07/',
    avatar: KieranLlarena,
    bio: `Kieran is a native Detroiter who has a passion for Software Engineering and is pursuing a Bachelor's of Science in Computer Science at the University of Michigan-Dearborn (May 2027). He is a motivated self-starter with a track record of adapting to different situations, integrating into team environments, and contributing to successful outcomes. With a background encompassing both frontend and backend development, Kieran possess an expertise in frontend development and UI/UX design, which he gained from prior internship experience that used technologies such as: React, SvelteKit, TypeScript, and Figma.`,
    university: 'University of Michigan - Dearborn',
    organization: '',
    position: '',
    devfest: 'devteam',
  },
  {
    id: 13,
    name: 'Zahraa Alhmood',
    linkedin: 'https://www.linkedin.com/in/zahraa-alhmood',
    github: 'https://github.com/Zahraa222',
    avatar: ZahraaAlhmood,
    bio: `Zahraa is a third-year Computer Engineering student at the University of Michigan-Dearborn. Her engagement with the tech community is highlighted through her role as the Marketing Director for the Google Developer Student Club at her university. Her hands-on experience extends to her position as Team Lead Engineer at NASA's L’SPACE Mission Concept Academy, showcasing her leadership and technical expertise.`,
    university: 'University of Michigan - Dearborn',
    organization: '',
    position: 'Junior',
    devfest: 'devteam',
  },
  {
    id: 14,
    name: 'Zavaar Shah',
    linkedin: 'https://linkedin.com/in/zavaar-shah',
    github: 'https://github.com/thatziv',
    avatar: ZavaarShah,
    bio: `Zavaar is currently a junior at Wayne State University studying Computer Science like many of you are. `,
    university: 'Wayne State University',
    organization: 'GDSC@Wayne State',
    position: 'President',
    devfest: 'devteam',
  },
  {
    id: 15,
    name: 'Hisham Odeh',
    linkedin: 'https://www.linkedin.com/in/hisham-odeh-4611081b0',
    github: 'https://github.com/Heshoo-ksh',
    avatar: HishamOdeh,
    bio: `Kieran is a native Detroiter who has a passion for Software Engineering and is pursuing a Bachelor's of Science in Computer Science at the University of Michigan-Dearborn (May 2027). He is a motivated self-starter with a track record of adapting to different situations, integrating into team environments, and contributing to successful outcomes. With a background encompassing both frontend and backend development, Kieran possess an expertise in frontend development and UI/UX design, which he gained from prior internship experience that used technologies such as: React, SvelteKit, TypeScript, and Figma.`,
    university: 'University of Michigan - Dearborn',
    organization: 'Epitec',
    position: 'Software Engineering Intern',
    devfest: 'devteam',
  },
  {
    id: 16,
    name: 'Mohamad Alabudi',
    linkedin: 'https://www.linkedin.com/in/malabudi',
    github: 'https://malabudi.github.io/',
    avatar: MohamadAlabudi,
    bio: `Mohamad is currently pursuing a Bachelor's in Software Engineering. His primary expertise lies in full-stack web development, supplemented by ongoing learning in AWS cloud technologies. He is keen to master industry-standard frameworks, explore mobile development, and deepen his cloud expertise. Some of his hobbies include playing music, 3D printing and gaming.`,
    university: 'University of Michigan - Dearborn',
    organization: '',
    position: '',
    devfest: 'devteam',
  },
  {
    id: 17,
    name: 'Shahd Mustafa',
    linkedin: 'https://www.linkedin.com/in/shahd-mustafa-194894252/',
    github: 'https://github.com/shahdmu34',
    avatar: ShahdMustafa,
    bio: `Kieran is a native Detroiter who has a passion for Software Engineering and is pursuing a Bachelor's of Science in Computer Science at the University of Michigan-Dearborn (May 2027). He is a motivated self-starter with a track record of adapting to different situations, integrating into team environments, and contributing to successful outcomes. With a background encompassing both frontend and backend development, Kieran possess an expertise in frontend development and UI/UX design, which he gained from prior internship experience that used technologies such as: React, SvelteKit, TypeScript, and Figma.`,
    university: 'University of Michigan - Dearborn',
    organization: '',
    position: '',
    devfest: 'devteam',
  },
]
